import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { LOCAL_DESTINATION_OFFER_CAROUSEL_REGIONS } from 'home/components/OfferCarousels/localDestinationOfferCarouselConstants'
import { isLocalDestinationOfferCarouselEnabled } from 'home/components/OfferCarousels/localDestinationOfferCarouselModel'

export function useIsLocalDestinationOfferCarouselEnabled(regionCode: string): boolean {
  const featureFlagEnabled = useFeatureFlag(OptimizelyFeatureFlags.croLocalDestinationOfferCarousel)

  return isLocalDestinationOfferCarouselEnabled(
    regionCode,
    LOCAL_DESTINATION_OFFER_CAROUSEL_REGIONS,
    featureFlagEnabled,
  )
}
